// composables/useConfirmModalState.ts
interface ModalState {
  isOpen: boolean
  title: string
  text: string
  options: object
  callback: ((result: boolean) => void) | null
}

export const useConfirmModalState = () => 
  useState<ModalState>('confirm-modal', () => ({
    isOpen: false,
    title: '',
    text: '',
    callback: null,
    options: {},
  }))